// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"bd97cbe4","216":"ea15b0dc","285":"8f4926ae","574":"36e6263e","630":"3f9b979d","673":"8f45ebbe","753":"5d609885","767":"0b6b88d9","782":"c0380074","835":"72e67631","854":"e288086c","868":"42581255","902":"b155215c","916":"e80f1d73"}[chunkId] + ".chunk.js";
};